export default "__VITE_ASSET__fefcf583__"